import * as d3 from 'd3'
import Chart from '../chart'

import './Pills.css'

export default class Pills extends Chart {
  create() {
    this.numberOfPills = 100;
    this.size = Math.max(this.props.width, this.props.height) * 0.02;
    this.padding = this.size * 1.5;
    this.backgroundColor = '#fffc79';
    this.pillsColor = '#ffb60a'//'#e91e63';
    this.seedAngle = 180 * Math.random();

    this.svg = super.createRoot();
    this.main = this.svg.append('g')
      .attr('class', 'main');

    
    this.emptyZone = { 
      left: 0.2 * this.props.width,
      right: 0.8 * this.props.width,
      top: 0.33 * this.props.height,
      bottom: 0.60 * this.props.height
    }
    /*this.title = this.main.append('g')
      .attr('class', 'title')
      .append('rect')
      .attr('x', this.emptyZone.left)
      .attr('y', this.emptyZone.top)
      .attr('width', this.emptyZone.right - this.emptyZone.left)
      .attr('height', this.emptyZone.bottom - this.emptyZone.top)
      .style('opacity', 0.3)*/
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    if (JSON.stringify(state) !== JSON.stringify(this.state)) {
      this.drawPills(state);
    }
  }

  appendPillsDrug(selection) {
    const pillSize = this.size*1.3
    const strokeWidth = pillSize*0.08
    selection.append("rect")
      .attr("x", -pillSize/2)
      .attr("y", -pillSize/4)
      .attr("width", pillSize)
      .attr("height", pillSize/2)
      .attr("rx", pillSize/4)
      .attr("ry", pillSize/4)
      .style("fill", "none")
      .style("stroke", this.pillsColor)
      .style("stroke-width", strokeWidth)
      .style("stoke-location", "outside")
    selection.append("rect")
      .attr("x", -pillSize/2)
      .attr("y", -pillSize/4)
      .attr("width", pillSize/2)
      .attr("height", pillSize/2)
      .attr("rx", pillSize/4)
      .attr("ry", pillSize/4)
      .style("fill", this.pillsColor)
      .style("stroke", this.pillsColor)
      .style("stroke-width", strokeWidth)
      .style("stoke-location", "outside")
    selection.append("line")
      .attr("x1", 0)
      .attr("x2", 0)
      .attr("y1", -pillSize/4)
      .attr("y2", pillSize/4)
      .style("fill", "none")
      .style("stroke", this.pillsColor)
      .style("stroke-width", strokeWidth*1.2)
  }

  appendRoundDrug(selection) {
    selection.append("circle")
      .attr("r", this.size/2)
      .attr("cx", 0)
      .attr("cy", 0)
      .style("fill", "none")
      .style("stroke", this.pillsColor)
      .style("stroke-width", this.size*0.1)
    selection.append("line")
      .attr("x1", - this.size/2)
      .attr("x2", this.size/2)
      .attr("y1", 0)
      .attr("y2", 0)
      .style("fill", "none")
      .style("stroke", this.pillsColor)
      .style("stroke-width", this.size*0.1)
  }

  drawPills(state) {
    const positions = this.getPositions(state.relativePosition)
    //this.main.selectAll('*').remove()
    const pills = this.main.selectAll(".pill")
      .data(positions)

    const pillsEnter = pills.enter()
      .append("g")
      .attr("class", "pill")
    
    if (!this.drawOnce) {
      const self = this;
      pillsEnter.each(function(d) {
        const selection = d3.select(this);
        const type = Math.random() < 0.4 ? 'round' : 'pill';
        switch(type) {
          case "round":
            self.appendRoundDrug(selection);
            break;
          case "pill":
            self.appendPillsDrug(selection);
            break;
          default:
            break;
        }
        selection.attr("transform", `translate(${d.x}, ${d.y}) rotate(${d.angle})`);
      })
    }

    pills
      .merge(pillsEnter)
      .attr("transform", d => `translate(${d.x}, ${d.y}) rotate(${d.angle})`);
    
    this.drawOnce = true;
  }

  getPositions(relativePosition) {
    const angle = Math.PI * (3 - Math.sqrt(5));
    return new Array(this.numberOfPills).fill(0).map((_, i) => {
      const initialR = (this.size + this.padding) * 1.2 * Math.sqrt(i);
      const r = (this.size + this.padding) * 1.2 * Math.sqrt(i) * (1 + (relativePosition || 0));
      const a = i * angle;
      const initialX = initialR * Math.cos(a);
      const initialY = initialR * Math.sin(a);
      const x = r * Math.cos(a);
      const y = r * Math.sin(a);
      return { 
        initialX: initialX + this.props.width/2, 
        initialY: initialY+ this.props.height/2, 
        x: x + this.props.width/2, 
        y: y + this.props.height/2, 
        angle: ((5 * i) + this.seedAngle + (relativePosition || 0) * 100) % 360 }
    })
    .filter(pos => {
      return (pos.initialX <= this.emptyZone.left ||
        pos.initialX >= this.emptyZone.right) ||(pos.initialY <= this.emptyZone.top ||
          pos.initialY >= this.emptyZone.bottom)
    })
  }
}





// WEBPACK FOOTER //
// ./src/components/charts/Pills/Pills.js